
<template lang="pug">
  transition(name="fade" :css="useTransition")
    .modal(v-if="isVisible" :class="{ visible: isVisible }" ref="modal")
      .modal__overlay(@click="close")
      .modal__content
        icon-button(label="Close Modal", icon="close", class="modal__close", @click="close" ref="modal-close")
        slot(name="content")
</template>

<script>
  import IconButton from 'scripts/components/buttons/IconButton.vue'

  export default {
    name: 'Modal',
    components: { IconButton },
    props: {
      autoOpen: {
        type: Boolean,
        default: false,
      },
      useTransition: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        isVisible: false,
      }
    },
    mounted() {
      if(this.autoOpen) {
        this.open();
      }
    },
    methods: {
      open () {
        this.isVisible = true

        document.addEventListener('keydown', this.closeModalOnEsc);
        document.addEventListener('focusin', this.onFocus);

        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs['modal-close'].$el.focus();
          }, 300);
        });
      },
      close () {
        this.isVisible = false

        document.removeEventListener('keydown', this.closeModalOnEsc);
        document.addEventListener('focusin', this.onFocus);
      },
      closeModalOnEsc (e) {
        if (e.key === 'Esc' || e.key === 'Escape') {
          this.close();
        }
      },
      onFocus(event) {
        if (this.$refs.modal) {
          if (!this.$refs.modal.contains(event.target)) {
            this.close();
          }
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100vh;
    width: 100%;
    overflow-y: auto;
    background-color: $color-transparent-black;
    opacity: 1;
    visibility: visible;
    pointer-events: unset;
  }

  .modal__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .modal__content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 50px;
    max-width: 100%;
    background-color: $bg--main;
    padding: 30px;

    @include mobile-only {
      min-height: 100vh;
      width: 100%;
      transform: translate(-50%, 50%);
    }

    @include tablet-up {
      top: 50px;
      padding: 45px;
      min-width: 800px;
    }
  }

  .modal__title {
    margin-bottom: $content-gutter;
  }

  .modal__close {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 44px;
    width: 44px;
    font-size: rem(36);
    line-height: 44px;
    padding: 8px;
    text-align: center;
  }
</style>
